import PropTypes from 'prop-types';
import ConnectionsListContainer from '../articleList/containers/connectionsListContainer';
import PanelHeader from '../sidebar/panelHeader/panelHeader';
import PanelPropTypes from '../sidebar/panel/panelPropTypes';

export default function Connections({ panel: { launchProps: { type } } }) {
  return (
    <div className="sidebar-scroll-panel sidebar-panel-default-appearance">
      <PanelHeader title="Connections" />
      <div className="sidebar-scroll-panel-body">
        <ConnectionsListContainer type={type} />
      </div>
    </div>
  );
}

Connections.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  panel: PropTypes.shape(PanelPropTypes).isRequired,
};
